import { Controller } from 'react-hook-form';
import Input from './Input';

export default function InputRhf({ name, control, label, rules, placeholder, ...rest }) {
  return (
    <Controller
      name={name}
      control={control}
      rules={rules}
      render={({ field: { onChange, value }, fieldState: { error } }) => {
        return (
          <Input
            {...rest}
            InputLabelProps={{ shrink: true }}
            error={error?.message}
            onChange={onChange}
            value={value || ''}
            fullWidth
            label={label}
            placeholder={placeholder ? placeholder : label}
          />
        );
      }}
    />
  );
}
